/**
 * HTTP layer for tenant info. The white-label branding and config for the active
 * tenant.
 *
 * Contains:
 * - fetchTenantInfo: the active tenant's info
 */
///api/carriersms/
import apiClient from '@sophocles/http-common';

export const fetchTenantInfo = () => apiClient.get(`/tenant/`).then(res => res.data);
